import {
  Box,
  Flex,
  Input,
  Select,
  Spacer,
  useDisclosure,
  useToast,
  Text,
} from "@chakra-ui/react";
import { Space, Spin, Table } from "antd";
import axios from "axios";
import { debounce, get } from "lodash";
import { useCallback, useEffect, useMemo, useState } from "react";
import {
  // RiDeleteBin6Line,
  RiEditLine,
  RiStarFill,
  RiStarLine,
} from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
// import { REQUEST_MASTER_CASESTUDY } from "../../store/casestudy/casestudyActionTypes";
// import CasestudyEditDrawer from "../drawer/CasestudyEditDrawer";
import ServicesEditDrawer from "../drawer/ServiceEditDrawer";
import CasestudyDeleteConfirmation from "../modals/CasestudyDeleteConfirmation";
import CasestudyDetailsModal from "../modals/CasestudyDetailsModal";
import {
  SET_META_DATA_FOR_PAGINATION,
  SET_SEARCH_TEXT,
} from "../../store/casestudy/casestudyActionTypes";
// import { setSearchText } from "../../store/casestudy/saga";

interface Props {
  query: string;
}

const ServicesTable: React.FC<Props> = ({ query }) => {
  const toast = useToast();
  const dispatch = useDispatch();
  const searchColumns = useMemo(() => ["title"], []);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [categoryNames, setCategoryNames] = useState<any[]>([]);
  const [filteredData, setFilteredData] = useState<any[]>([]);
  const [categoryFilter, setCategoryFilter] = useState<string>("All");
  const [casestudyData, setCasestudyData] = useState<any>();
  // const [userDetail, setUserDetail] = useState<any>("");
  const [showFavoritesOnly, setShowFavoritesOnly] = useState(false);
  const [targetevent, setTargetEvent] = useState<any>();
  const [loading, setloading] = useState(true);
  const [mainCategories, setMainCategories] = useState<any>([]);
  const [subCategories, setSubCategories] = useState<any>([]);
  const [serviceTypes, setServiceTypes] = useState<any>([]);
  const [selectedMainCategory, setSelectedMainCategory] = useState<string>("");
  const [selectedSubCategory, setSelectedSubCategory] = useState<string>("");
  const [selectedServiceType, setSelectedServiceType] = useState<string>("");
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const metaData = useSelector((state: any) => state.casestudy.meta);
  // console.log("metaData", metaData);
  const searchText = useSelector((state: any) => state.casestudy.searchText);

  const [searchQuery, setSearchQuery] = useState("");

  const search = (casestudy: Record<string, any>) => {
    return searchColumns.some((column) => {
      return (
        get(casestudy, column, "")
          .toString()
          .toLowerCase()
          .indexOf(searchQuery.toLowerCase()) > -1
      );
    });
  };

  const {
    isOpen: isViewOpen,
    // onOpen: onViewOpen,
    onClose: onViewClose,
  } = useDisclosure();

  const {
    isOpen: isDeleteOpen,
    // onOpen: onDeleteOpen,
    onClose: onDeleteClose,
  } = useDisclosure();

  // const {
  //   isOpen: isUpdateOpen,
  //   onOpen: onUpdateOpen,
  //   onClose: onUpdateClose,
  // } = useDisclosure();

  // const {
  // onOpen: onSlotDrawerOpen,
  // isOpen: isSlotDrawerOpen,
  // onClose: onSlotDrawerClose,
  // } = useDisclosure();

  // const handleSlotClick = (record: any) => {
  //   setTargetEvent(record);
  //   onSlotDrawerOpen();
  // };
  // const handleView = (record: any) => {
  //   setTargetEvent(record);
  //   onViewOpen();
  // };

  // const updateEvent = (record: any) => {
  //   setTargetEvent(record);
  //   onOpen();
  // };

  // const handleDelete = (record: any) => {
  //   setTargetEvent(record);
  //   onDeleteOpen();
  // };

  useEffect(() => {
    const getMainCategories = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/admin/mainCategory`
        );
        setMainCategories(response.data);
        console.log("mainCategories", response.data);
      } catch (error) {
        console.log(error);
      }
    };

    getMainCategories();
  }, []);

  useEffect(() => {
    const getSubCategories = async () => {
      if (!selectedMainCategory) {
        setSubCategories([]);
        return;
      }

      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/admin/subCategory?mainCategoryId=${selectedMainCategory}`
        );
        setSubCategories(response.data);
        setSelectedSubCategory("");
        setSelectedServiceType("");
        setServiceTypes([]);
      } catch (error) {
        console.log(error);
        toast({
          title: "Error",
          description: "Failed to fetch subcategories",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    };

    getSubCategories();
  }, [selectedMainCategory]);

  useEffect(() => {
    const getServiceTypes = async () => {
      if (!selectedSubCategory) {
        setServiceTypes([]);
        return;
      }

      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/admin/service?subCategoryId=${selectedSubCategory}`
        );
        setServiceTypes(response.data);

        setSelectedServiceType("");
      } catch (error) {
        console.log(error);
        toast({
          title: "Error",
          description: "Failed to fetch service types",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    };

    getServiceTypes();
  }, [selectedSubCategory]);

  useEffect(() => {
    const getCategoryNames = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/category/names`
        );

        setCategoryNames(["All", ...response.data]);
      } catch (error) {
        console.log(error);
      }
    };

    getCategoryNames();
  }, []);

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    // setCategoryFilter(event.target.value);
    setPagination((p) => ({ ...p, current: 1 }));
    debouncedSearch(event.target.value === "All" ? "" : event.target.value);
    setSearchQuery("");
  };
  useEffect(() => {
    const metaLimit = Number(metaData?.limit) || 10;
    const page = Number(metaData?.page) || 1;

    let total = 0;
    if (metaData?.totalPages != null && !isNaN(metaData?.totalPages)) {
      total = Number(metaData?.totalPages) * metaLimit;
    } else {
      // totalPages unknown: allow one extra page if hasNextPage true
      if (metaData?.hasNextPage) {
        total = (page + 1) * metaLimit;
      } else {
        total = page * metaLimit;
      }
    }

    setPagination((p) => ({
      ...p,
      current: page,
      pageSize: metaLimit,
      total,
    }));
  }, [metaData]);

  //   useEffect(() => {
  //   const q = searchText.trim().toLowerCase();
  //   const timer = setTimeout(() => {
  //     dispatch<any>(getServiceDetails(selectedLang, 1, pagination.pageSize, q));
  //     setPagination((p) => ({ ...p, current: 1 }));
  //   }, 500);

  //   return () => clearTimeout(timer);
  // }, [searchText, dispatch, selectedLang, pagination.pageSize]);

  useEffect(() => {
    if (!categoryFilter) return;
    // if (!selectedServiceType) return;
    // console.log("selectedServiceType", selectedServiceType);

    dispatch({
      type: "REQUEST_MASTER_CASESTUDY",
      payload: {
        serviceId: selectedServiceType,
        type: categoryFilter,
        isFav: showFavoritesOnly ? true : undefined,
        page: pagination.current,
        pageSize: pagination.pageSize,
        searchText: searchQuery || searchText,
      },

      onSuccess: (response: any) => {
        // console.log("Fetched casestudy successfully:", response.data);

        dispatch({
          type: SET_META_DATA_FOR_PAGINATION,
          payload: response.meta,
        });
        const transformedData = response.data.map(
          (casestudy: any, index: number) => ({
            key: casestudy._id,
            index: index + 1,
            title: casestudy.title,
            image: `${process.env.REACT_APP_IMAGE_BASE_URL}/${casestudy.imageURL}`,
            casestudyId: casestudy.caseStydyId,
            createdDate: new Date(casestudy.createdAt).toLocaleDateString(),
            description: casestudy.description,
            subcategory: casestudy.subCategory,
            type: casestudy.type,
            isFav: casestudy.isFav,
            originalData: casestudy,
            url: `https://10turtle.com/work/${casestudy.titleUrl}`,
          })
        );
        // const filtered = searchQuery
        //   ? transformedData.filter(search)
        //   : transformedData;
        setFilteredData(transformedData);
        setloading(false);
      },
      onError: (error: any) => {
        console.error("Error fetching casestudy:", error);
        setloading(false);
        toast({
          title: "Error",
          description: "Failed to fetch case studies.",
          status: "error",
          duration: 3000,
          isClosable: true,
          position: "top-right",
        });
      },
    });
  }, [
    categoryFilter,
    searchQuery,
    showFavoritesOnly,
    selectedMainCategory,
    selectedSubCategory,
    selectedServiceType,
    pagination.current,
    searchText,
  ]);

  const handleTableChange = (pag: any) => {
    // const q = searchText.trim().toLowerCase();
    // dispatch<any>(
    //   getServiceDetails(selectedLang, pag.current, pag.pageSize, q)
    // );
    console.log("Pagination changed:", pag);

    setPagination((p) => ({
      ...p,
      current: pag.current,
      pageSize: pag.pageSize,
    }));
  };
  console.log("searchText", searchText);

  const debouncedSearch = useCallback(
    debounce((value: string) => {
      dispatch({
        type: SET_SEARCH_TEXT,
        payload: value,
      });
    }, 500), // 500ms delay
    [dispatch]
  );
  const handleSearch = (value: string) => {
    setPagination((p) => ({ ...p, current: 1 }));
    debouncedSearch(value);
    setSearchQuery(value);
  };

  const SingleImage = ({ image }: { image: string }) => (
    <div
      style={{
        width: 36,
        height: 36,
        borderRadius: "50%",
        overflow: "hidden",
        backgroundColor: "white",
      }}
    >
      <img
        src={image}
        alt="Banner"
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
        }}
      />
    </div>
  );

  const handleFavoriteToggle = async (record: any) => {
    // console.log("record", record);
    try {
      await handleCasestudy(record);

      let serviceIds = record.originalData?.serviceId?.map(
        (service: any) => service._id || service
      );

      const updatePayload: any = {
        caseStydyId: record.originalData.caseStydyId,
        banner_title: record.originalData.title,
        banner_description: record.originalData.description,
        banner_type: record.originalData.type,
        banner_imageURL: record.originalData.imageURL,
        banner_subCategory: record.originalData.subCategory,
        serviceId: serviceIds || [],
        isFav: !record.isFav,
      };
      console.log("record.originalData.videoURL", record.originalData.videoURL);

      if (
        record.originalData.videoURL &&
        record.originalData.videoURL.trim() !== ""
      ) {
        updatePayload.banner_videoURL = record.originalData.videoURL;
      }
      console.log("updatePayload", updatePayload);

      const response = await axios({
        method: "patch",
        url: `${process.env.REACT_APP_BASE_URL}/admin/category/update/${record.originalData._id}`,
        data: updatePayload,
      });

      console.log("Favorite update response:", response);

      dispatch({
        type: "REQUEST_MASTER_CASESTUDY",
        payload: {
          type: categoryFilter,
        },

        onSuccess: (response: any) => {
          console.log("Fetched casestudy successfully:", response);

          const transformedData = response.data.map(
            (casestudy: any, index: number) => ({
              key: casestudy._id,
              index: index + 1,
              title: casestudy.title,
              image: `${process.env.REACT_APP_IMAGE_BASE_URL}/${casestudy.imageURL}`,
              casestudyId: casestudy.caseStydyId,
              createdDate: new Date(casestudy.createdAt).toLocaleDateString(),
              description: casestudy.description,
              subcategory: casestudy.subCategory,
              type: casestudy.type,
              isFav: casestudy.isFav,
              originalData: casestudy,
              url: `https://10turtle.com/work/${casestudy.titleUrl}`,
            })
          );
          const filtered = searchQuery
            ? transformedData.filter(search)
            : transformedData;

          setFilteredData(filtered);
          setloading(false);
        },
        onError: (error: any) => {
          console.error("Error fetching casestudy:", error);
          setloading(false);
          toast({
            title: "Error",
            description: "Failed to fetch case studies.",
            status: "error",
            duration: 3000,
            isClosable: true,
            position: "top-right",
          });
        },
      });

      toast({
        title: "Success",
        description: `Case study ${
          record.isFav ? "removed from" : "added to"
        } favorites`,
        status: "success",
        duration: 3000,
        isClosable: true,
        position: "top-right",
      });
    } catch (error) {
      console.error("Error updating favorite status:", error);
      toast({
        title: "Error",
        description: "Failed to update favorite status",
        status: "error",
        duration: 3000,
        isClosable: true,
        position: "top-right",
      });
    }
  };

  const columns = [
    {
      title: "Nos.",
      dataIndex: "index",
      width: 80,
      render: (_: any, __: any, index: number) => `#${index + 1}`,
    },
    {
      title: "Image",
      dataIndex: "image",
      width: 100,
      render: (image: string) => <SingleImage image={image} />,
    },
    {
      title: "Title",
      dataIndex: "title",
      width: 200,
    },
    {
      title: "Description",
      dataIndex: "description",
      width: 250,
      render: (_: any, record: any) => {
        const serviceBadges: any = [];

        if (
          record.originalData &&
          record.originalData.serviceId &&
          record.originalData.serviceId.length > 0
        ) {
          record.originalData.serviceId.forEach(
            (service: any, index: number) => {
              if (service.mainCategoryId && service.title) {
                const mainCategoryTitle = service.mainCategoryId.title || "";
                const subCategoryTitle = service.subCategoryId.title || "";
                const serviceTitle = service.title || "";

                serviceBadges.push(
                  <span
                    key={index}
                    style={{
                      backgroundColor: "#f0f0f0",
                      padding: "2px 8px",
                      borderRadius: "12px",
                      marginRight: "8px",
                      fontSize: "12px",
                      color: "#333",
                      display: "inline-block",
                      marginBottom: "5px",
                    }}
                  >
                    {serviceTitle} [ {mainCategoryTitle} ({subCategoryTitle})]
                  </span>
                );
              }
            }
          );
        }

        return (
          <div>
            <div style={{ marginTop: "8px" }}>{serviceBadges}</div>
          </div>
        );
      },
    },
    {
      title: "Type",
      dataIndex: "type",
      width: 150,
    },
    {
      title: "Sub Category",
      dataIndex: "subcategory",
      width: 150,
    },
    {
      title: "Created Date",
      dataIndex: "createdDate",
      width: 150,
    },
    {
      title: "Actions",
      key: "actions",
      width: 150,
      render: (_: any, record: any) => {
        // console.log("record", record);

        return (
          <Space size="middle">
            <RiEditLine
              style={{
                color: "#000",
                cursor: "pointer",
                height: "20px",
                width: "20px",
              }}
              onClick={async () => {
                await handleCasestudy(record);
                setTargetEvent(record.originalData);
                onOpen();
              }}
            />
            {record.isFav ? (
              <RiStarFill
                style={{
                  color: "#ffe234",
                  cursor: "pointer",
                  height: "20px",
                  width: "20px",
                }}
                onClick={() => handleFavoriteToggle(record)}
              />
            ) : (
              <RiStarLine
                style={{
                  color: "#ffe234",
                  cursor: "pointer",
                  height: "20px",
                  width: "20px",
                }}
                onClick={() => handleFavoriteToggle(record)}
              />
            )}
          </Space>
        );
      },
    },
  ];

  const handleCasestudy = async (record: any) => {
    // console.log("record", record);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/caseStudy/getById/${record.originalData.titleUrl}`
      );
      console.log("response", response.data);
      setCasestudyData(response.data);
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };

  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  // const rowSelection = {
  //   selectedRowKeys,
  //   onChange: onSelectChange,
  // };

  console.log("monillllll", searchText);
  return (
    <>
      <div
        style={{
          width: "96vw",
          maxWidth: "96vw",
          maxHeight: "86vh",
          height: "86vh",
          top: "8vh ",
          left: "4vw",
          overflowY: "auto",
          position: "relative",
          backgroundColor: "#EEEEEE",
          padding: "30px",
        }}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          <Flex w="full" alignItems="center" justifyContent="space-between">
            <Box
              display="flex"
              alignItems="center"
              bg="#FFF"
              border="1px solid #b2b2b233"
              borderRadius="12px"
              w="400px"
              padding="8px"
            >
              <Box
                pl={2}
                display="flex"
                alignItems="center"
                color="#9E9E9E"
                fontSize="2xl"
              >
                <img
                  src="/icons/searchlogo.svg"
                  alt="searchlogo"
                  style={{ height: "24px", width: "24px" }}
                />
              </Box>

              <Input
                id="search"
                type="text"
                placeholder="Search or type a command"
                onChange={(e: any) => handleSearch(e.target.value)}
                value={searchQuery}
                fontSize="sm"
                border="none"
                outline="none"
                color="#757575"
                _focus={{
                  border: "none",
                  outline: "none",
                  boxShadow: "none",
                }}
                bg={"transparent"}
                style={{
                  outline: "none",
                  boxShadow: "none",
                }}
              />
            </Box>

            <Spacer />

            <Box
              // maxW={"100%"}
              display={"flex"}
              alignItems={"center"}
              justifyContent={"flex-end"}
              marginLeft="20px"
            >
              {/* <Select
                placeholder="Select Main Category"
                value={selectedMainCategory}
                onChange={(e: any) => {
                  const mainCategoryId = e.target.value;
                  setSelectedMainCategory(mainCategoryId);
                  // setFieldValue("main_category", mainCategoryId);
                }}
                bg="#FFF"
                marginRight="10px"
              >
                {mainCategories.map((category: any) => (
                  <option key={category._id} value={category._id}>
                    {category.title}
                  </option>
                ))}
              </Select>
              <Select
                placeholder="Select Sub Category"
                value={selectedSubCategory}
                onChange={(e: any) => {
                  const subCategoryId = e.target.value;
                  setSelectedSubCategory(subCategoryId);
                  // setFieldValue("sub_category", subCategoryId);
                }}
                bg="#FFF"
                isDisabled={!selectedMainCategory}
                marginRight="10px"
              >
                {subCategories.map((subCategory: any) => (
                  <option key={subCategory._id} value={subCategory._id}>
                    {subCategory.title}
                  </option>
                ))}
              </Select>
              <Select
                placeholder="Select Service Type"
                value={selectedServiceType}
                onChange={(e: any) => {
                  const serviceId = e.target.value;
                  setSelectedServiceType(serviceId);
                  // setFieldValue("service_type", serviceId);
                }}
                bg="#FFF"
                isDisabled={!selectedSubCategory}
                marginRight="10px"
              >
                {serviceTypes.map((service: any) => (
                  <option key={service._id} value={service._id}>
                    {service.title}
                  </option>
                ))}
              </Select> */}
              <Box
                display={"flex"}
                background={showFavoritesOnly ? "#000" : "#fff"}
                w="fit-content"
                textAlign="center"
                gap={2}
                px={3}
                py={2}
                // marginRight="10px"
                marginRight={3}
                borderRadius="8px"
                border={"1px solid transparent"}
                transition="0.3s"
                _hover={{
                  transition: "0.3s",
                  border: "1px solid #000",
                }}
                cursor="pointer"
                onClick={() => setShowFavoritesOnly(!showFavoritesOnly)}
              >
                {showFavoritesOnly ? (
                  <RiStarFill
                    style={{
                      color: "#fff",
                      cursor: "pointer",
                      height: "20px",
                      width: "20px",
                    }}
                  />
                ) : (
                  <RiStarLine
                    style={{
                      color: "#000",
                      cursor: "pointer",
                      height: "20px",
                      width: "20px",
                    }}
                  />
                )}
                <Text
                  fontSize="sm"
                  color={showFavoritesOnly ? "#fff" : "#000"}
                  fontWeight="500"
                  display="inline-block"
                  marginBottom="0px"
                >
                  Favourite
                </Text>
              </Box>
              <Select
                defaultValue="All"
                // style={{ width: 200 }}
                onChange={(event: any) => handleChange(event)}
                value={searchText}
                bg="#FFF"
                marginRight="10px"
              >
                {categoryNames.map((category) => (
                  <option key={category} value={category}>
                    {category}
                  </option>
                ))}
              </Select>
            </Box>
          </Flex>

          <Spacer></Spacer>
          <Table
            columns={columns}
            dataSource={filteredData}
            loading={loading}
            rowKey="_id"
            onChange={handleTableChange}
            pagination={{
              current: pagination.current,
              pageSize: pagination.pageSize,
              total: pagination.total,
              // showSizeChanger: true,
              showQuickJumper: true,
              showTotal: (total) =>
                `Showing page ${pagination.current} — approx ${total} items`,
            }}
            locale={{ emptyText: loading ? <Spin /> : "No data" }}
          />

          {/* <Table
            rowSelection={rowSelection}
            columns={columns}
            dataSource={filteredData}
            scroll={{ x: "max-content" }}
            size="middle"
            style={{
              backgroundColor: "white",
              borderRadius: 6,
            }}
            pagination={{
              position: ["bottomRight"],
              pageSize: 10,
            }}
          /> */}
        </div>
      </div>

      {isOpen && (
        <ServicesEditDrawer
          isOpen={isOpen}
          onClose={onClose}
          bannerData={targetevent}
          casestudyData={casestudyData}
          refreshData={() => {
            dispatch({
              type: "REQUEST_MASTER_CASESTUDY",
              payload: {
                serviceId: selectedServiceType,
                type: categoryFilter,
              },
              onSuccess: (response: any) => {
                console.log("Fetched casestudy successfully:", response);

                const transformedData = response.data.map(
                  (casestudy: any, index: number) => ({
                    key: casestudy._id,
                    index: index + 1,
                    title: casestudy.title,
                    image: `${process.env.REACT_APP_IMAGE_BASE_URL}/${casestudy.imageURL}`,
                    casestudyId: casestudy.caseStydyId,
                    createdDate: new Date(
                      casestudy.createdAt
                    ).toLocaleDateString(),
                    description: casestudy.description,
                    isFav: casestudy.isFav,
                    originalData: casestudy,
                    subcategory: casestudy.subCategory,
                    type: casestudy.type,
                    url: `https://10turtle.com/work/${casestudy.titleUrl}`,
                  })
                );
                const filtered = searchQuery
                  ? transformedData.filter(search)
                  : transformedData;

                setFilteredData(filtered);
              },
              onError: (error: any) => {
                console.error("Error fetching casestudy:", error);
                toast({
                  title: "Error",
                  description: "Failed to fetch case studies.",
                  status: "error",
                  duration: 3000,
                  isClosable: true,
                  position: "top-right",
                });
              },
            });
          }}
        />
      )}

      {isViewOpen && (
        <CasestudyDetailsModal
          isOpen={isViewOpen}
          onClose={onViewClose}
          restaurantData={targetevent}
        />
      )}

      {isDeleteOpen && targetevent && (
        <CasestudyDeleteConfirmation
          isOpen
          bannerData={targetevent}
          onDeleteClose={onDeleteClose}
          refreshData={() => {
            dispatch({
              type: "REQUEST_MASTER_CASESTUDY",
              payload: {
                serviceId: selectedServiceType,
                type: categoryFilter,
              },
              onSuccess: (response: any) => {
                console.log("Fetched casestudy successfully:", response);

                const transformedData = response.data.map(
                  (casestudy: any, index: number) => ({
                    key: casestudy._id,
                    index: index + 1,
                    title: casestudy.title,
                    image: `${process.env.REACT_APP_IMAGE_BASE_URL}/${casestudy.imageURL}`,
                    casestudyId: casestudy.caseStydyId,
                    createdDate: new Date(
                      casestudy.createdAt
                    ).toLocaleDateString(),
                    description: casestudy.description,
                    originalData: casestudy,
                    subcategory: casestudy.subCategory,
                    type: casestudy.type,
                    url: `https://10turtle.com/work/${casestudy.titleUrl}`,
                  })
                );
                const filtered = searchQuery
                  ? transformedData.filter(search)
                  : transformedData;

                setFilteredData(filtered);
              },
              onError: (error: any) => {
                console.error("Error fetching casestudy:", error);
                toast({
                  title: "Error",
                  description: "Failed to fetch case studies.",
                  status: "error",
                  duration: 3000,
                  isClosable: true,
                  position: "top-right",
                });
              },
            });
          }}
        />
      )}
    </>
  );
};

export default ServicesTable;
